import React from 'react'

import Icon from '@ant-design/icons'

const StarIconSvg = () => (
  <svg
    width="54"
    height="51"
    viewBox="0 0 54 51"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M53.6667 19.64L34.4933 17.9867L27 0.333374L19.5067 18.0134L0.333344 19.64L14.8933 32.2534L10.52 51L27 41.0534L43.48 51L39.1333 32.2534L53.6667 19.64ZM27 36.0667L16.9733 42.12L19.64 30.7067L10.7867 23.0267L22.4667 22.0134L27 11.2667L31.56 22.04L43.24 23.0534L34.3867 30.7334L37.0533 42.1467L27 36.0667Z" />
  </svg>
)

export const StarIcon = (props: any) => (
  <Icon component={StarIconSvg} {...props} />
)
